module.exports = __webpack_public_path__ + "assets/img/00024.cb7dd38e.png";